import React, { useState } from "react";
import { Star } from "lucide-react";

import { cn } from "lib/utils";

interface StarRatingInputProps {
    value: number;
    onChange: (value: number) => void;
    max?: number;
    className?: string;
    starClassName?: string;
    "aria-label": string;
}

const StarRatingInput: React.FC<StarRatingInputProps> = ({
    value,
    onChange,
    max = 5,
    className,
    starClassName,
    "aria-label": ariaLabel,
}) => {
    const [hover, setHover] = useState(0);
    const displayed = hover || value;

    return (
        <div role="radiogroup" aria-label={ariaLabel} className={cn("flex gap-1", className)}>
            {Array.from({ length: max }, (_, index) => {
                const starValue = index + 1;
                const isFilled = starValue <= displayed;

                return (
                    <button
                        key={starValue}
                        type="button"
                        role="radio"
                        aria-checked={value === starValue}
                        onClick={() => onChange(starValue)}
                        onMouseEnter={() => setHover(starValue)}
                        onMouseLeave={() => setHover(0)}
                        className="rounded-sm transition-transform hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
                    >
                        <Star
                            aria-hidden
                            className={cn(
                                "h-9 w-9",
                                starClassName,
                                isFilled
                                    ? "fill-amber-400 stroke-amber-400"
                                    : "fill-transparent stroke-slate-300",
                            )}
                        />
                    </button>
                );
            })}
        </div>
    );
};

export default StarRatingInput;
